import { render, staticRenderFns } from "./PositionsPage.vue?vue&type=template&id=65451022&scoped=true"
import script from "./PositionsPage.vue?vue&type=script&lang=js"
export * from "./PositionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65451022",
  null
  
)

export default component.exports